import React from 'react';

const ERROR_MESSAGE =
  'The checkpoint prop should be boolean/number or array of boolean/number';

const isExpectedValueType = (value) =>
  typeof value === 'boolean' || typeof value === 'number';

export function BinaryRenderer({ checkpoint, children, fallback }) {
  let cp = true;
  if (checkpoint instanceof Array) {
    checkpoint.forEach((cpItem) => {
      if (!isExpectedValueType(cpItem)) throw new Error(ERROR_MESSAGE);
      cp = cp && cpItem;
    });
  } else if (isExpectedValueType(checkpoint)) {
    cp = checkpoint;
  } else {
    throw new Error(ERROR_MESSAGE);
  }

  const f = fallback || null;

  return <React.Fragment>{cp ? children : f}</React.Fragment>;
}
